import { render, staticRenderFns } from "./MunicipioIssForm.vue?vue&type=template&id=073f93f8"
import script from "./MunicipioIssForm.vue?vue&type=script&lang=js"
export * from "./MunicipioIssForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports